import { render, staticRenderFns } from "./SuperAdminMerchantWalletInfo.vue?vue&type=template&id=61cee886&scoped=true&lang=pug"
import script from "./SuperAdminMerchantWalletInfo.vue?vue&type=script&lang=ts"
export * from "./SuperAdminMerchantWalletInfo.vue?vue&type=script&lang=ts"
import style0 from "./SuperAdminMerchantWalletInfo.vue?vue&type=style&index=0&id=61cee886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cee886",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VChip,VForm,VIcon,VTextField})
